import { Text } from "ilenia";
import React, { FC, useEffect } from "react";

import { ariaLabelHeading } from ".";
import { setAcknowledgedWhatsNew } from "../../../api";
import { ShellSecondaryDataResponseBody } from "../../../types";
import NotificationItem from "./notificationItem";
import { Empty, StyledList } from "./styled";

interface INotificationList {
  items: ShellSecondaryDataResponseBody["notifications"];
  businessUserId: string;
  onItemClicked: (
    event: React.MouseEvent | React.KeyboardEvent,
    id: string,
    action: { type?: string; descriptor?: string; path?: string },
    read: boolean,
    type: string,
  ) => void;
  trackNotificationItemUrlClicked: (id: string, title: string, target: string) => Promise<void>;
}

const NotificationList: FC<INotificationList> = ({
  items,
  businessUserId,
  onItemClicked,
  trackNotificationItemUrlClicked,
}) => {
  useEffect(() => {
    const setAcknowledged = async () => {
      const productUpdates = items.filter((item) => item.type === "productUpdate");
      const hasUnacknowledgedItems = productUpdates.some((item) => item.state === "new");
      if (hasUnacknowledgedItems) {
        const acknowledgedItems = productUpdates.map(({ id }) => id);
        await setAcknowledgedWhatsNew(acknowledgedItems, businessUserId);
      }
    };
    setAcknowledged();
  }, []);

  return (
    <StyledList aria-labelledby={ariaLabelHeading}>
      {items.length ? (
        <>
          {items.map((itemProps) => {
            return (
              <NotificationItem
                key={itemProps.id}
                {...itemProps}
                onItemClicked={onItemClicked}
                trackNotificationItemUrlClicked={trackNotificationItemUrlClicked}
              />
            );
          })}
        </>
      ) : (
        <Empty>
          <Text id="BusinessUserSettings.notifications.productUpdates.empty" />
        </Empty>
      )}
    </StyledList>
  );
};

export default NotificationList;
